import * as PropTypes from 'prop-types';
import * as React from 'react';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import CreditCardIcon from './credit_card_icon';
import UrlHelpers from '../shared/url_helpers';

class CreditCardBox extends React.Component {
  get cardId() {
    return this.props.creditCard.creditCardId;
  }

  displayExtendedAddress() {
    if (!this.props.creditCard.extendedAddress) { return <br />; }

    return <div>{this.props.creditCard.extendedAddress}</div>;
  }

  displayCardAddress() {
    const { locality, region, postalCode } = this.props.creditCard;
    if (locality && region && postalCode) {
      return `${locality}, ${region} ${postalCode}`;
    }
    return null;
  }

  address() {
    return (
      <li className="cc-details-list__item cc-details__address">
        {this.props.creditCard.cardholderName}
        <br />
        {this.props.creditCard.streetAddress}
        {this.displayExtendedAddress()}
        {this.displayCardAddress()}
      </li>
    );
  }

  handleMakePrimaryClick() {
    const path = UrlHelpers.makeDefaultCreditCardPath(this.cardId);
    APIRequest.put(path).done(() => {
      this.props.updatePrimaryCard(this.cardId);
    });
  }

  makePrimaryAction() {
    if (this.props.isPrimary) {
      return (
        <li
          data-primary-card-id={this.cardId}
          className="cc-details-list__item strong"
        >
          {I18n.t('js.creditCards.creditCardBox.primary')}
        </li>
      );
    }
    return (
      <li className="cc-details-list__item strong">
        <a
          data-make-credit-card-primary-id={this.cardId}
          onClick={() => this.handleMakePrimaryClick()}
        >
          {I18n.t('js.creditCards.creditCardBox.makePrimary')}
        </a>
      </li>
    );
  }

  editAction() {
    return (
      <li className="cc-details-list__item cc-details__edit">
        <a
          data-edit-credit-card-id={this.cardId}
          className="boxed-list__action"
          onClick={this.props.nowEditing}
        >
          {I18n.t('js.creditCards.creditCardBox.edit')}
        </a>
      </li>
    );
  }

  render() {
    return (
      <div className="cc-details">
        <ul className="cc-details-list">
          <li className="cc-details-list__item">
            <div className="cc-details__card">
              <div className="cc-details__icon">
                <CreditCardIcon cardType={this.props.creditCard.cardType} />
              </div>
              <div className="cc-details__card-info">
                <div className="cc-details__card-type">
                  {I18n.t('js.creditCards.creditCardBox.cardTypeAndLastFour', { cardType: this.props.creditCard.cardType, lastFour: this.props.creditCard.lastFour })}
                </div>
                <div className="cc-details__expiration">
                  {I18n.t('js.creditCards.creditCardBox.expiration', { month: this.props.creditCard.expirationMonth, year: this.props.creditCard.expirationYear })}
                </div>
              </div>
            </div>
          </li>
          {this.address()}
        </ul>
        <ul className="cc-details-list cc-details-list--actions">
          {this.makePrimaryAction()}
          {this.editAction()}
        </ul>
      </div>
    );
  }
}

CreditCardBox.propTypes = {
  creditCard: PropTypes.shape({
    creditCardId: PropTypes.string,
    cardType: PropTypes.string,
    lastFour: PropTypes.string,
    cardholderName: PropTypes.string,
    expirationMonth: PropTypes.string,
    expirationYear: PropTypes.string,
    streetAddress: PropTypes.string,
    extendedAddress: PropTypes.string,
    locality: PropTypes.string,
    region: PropTypes.string,
    postalCode: PropTypes.string,
    countryCode: PropTypes.string,
  }).isRequired,
  isPrimary: PropTypes.bool.isRequired,
  nowEditing: PropTypes.func.isRequired,
  updatePrimaryCard: PropTypes.func.isRequired,
};

export default CreditCardBox;



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/credit_card_box.jsx